import React from 'react';
import { Layout, Button, Modal, message } from 'antd';
import './HeaderPageCSS.css';
import logo from '../assets/MANIKBAG LOGO.png';
import { useNavigate } from 'react-router-dom';

const { Header } = Layout;

const HeaderPage = () => {

  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  const showLogoutConfirm = () => {
    Modal.confirm({
      title: 'Are you sure you want to logout?',
      okText: 'OK',
      cancelText: 'Cancel',
      onOk: () => {
        sessionStorage.clear();
        messageApi.success('Logout successful !');
        navigate('/');
      },
    });
  };

  return (
    <div className="row m-0 custom-header shadow py-2 py-md-0">
     {contextHolder}

      <div className="col-3 col-lg-1">
        <div className="logo-section p-1">
          <img src={logo} alt="Logo" className="logo" />
        </div>
      </div>
      <div className="col-9 col-lg-9 d-flex align-items-center justify-content-start">
        <span className="title">MANIKBAG DIGAMBAR JAIN BOARDING</span>
      </div>
      <div className="col-12 col-lg-2 d-flex align-items-center justify-content-end">
        <Button type="primary" className='logout-button' onClick={showLogoutConfirm}>
          Logout
        </Button>
      </div>
    </div>
  );
};

export default HeaderPage;
